import { useApolloClient } from '@apollo/client';
import { useState } from 'react';
import { Alert, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { GET_CATEGORIES } from '../../../graphql/org-gql';
import { ICategory, IOrg, isCategory } from '../../../types/org';
import { CancelIcon, MoveIcon } from '../../common/icons';
import OrgTree from '../../common/org-tree/org-tree';
import Button from '../../common/button';

type MovePositionProps = {
    isOpen: boolean,
    toggle: () => void
    onMoveHandle: (org:IOrg|undefined) => void
}

const MovePositionDialog = (props: MovePositionProps) => {
    const { isOpen,toggle,onMoveHandle} = props
    const [destOrg,setDestOrg] = useState<IOrg>();
    const [msg,setMsg] =  useState<string>('');
    const client = useApolloClient()
    const { categories } = client.readQuery({ query: GET_CATEGORIES }) ?? {}; // fallback to empty object to avoid NPE if data is not found in cache

    const onClickHide = () => {
        toggle()
    }

    const onClickOk = () => {
        toggle()
        onMoveHandle(destOrg)
    }

    const onSelectOrgHandle = (org?: ICategory | IOrg) => {
        //console.log("dest Org:",org);
        if (org && !isCategory(org))
            setDestOrg(org)
        if(!org || isCategory(org))
            setDestOrg(undefined)
    }

    return <div className='confirm'>
         <Modal id='movePosition' size="lg" role="alertdialog"  isOpen={isOpen} toggle={toggle} backdrop="static" scrollable={true}>
            <ModalHeader toggle={toggle} tag={'h2'}>Move Selected Positions/Roles</ModalHeader>
            <ModalBody >
                {msg&& <Alert color="danger" style={{margin:'0px'}}> {msg}</Alert>}
                <div >Please select which organization you would like to move the selected positions/roles to.</div>
                <div className='row' style={{maxHeight:'350px',overflowY:"auto",border: '1px solid var(--bs-border-color-translucent)',margin:'1px',padding:'5px'}}>
                {categories && (
                    <OrgTree roots={categories || []} isGlobal={false} onSelected={onSelectOrgHandle}></OrgTree>
                )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color='primary' onClick={onClickOk} disabled={!destOrg||!!msg}>
                    <MoveIcon/> Move
                </Button>
                <Button color="secondary" onClick={onClickHide}>
                    <CancelIcon/> Close
                </Button>
            </ModalFooter>
        </Modal>
        </div>
}

export default MovePositionDialog;
